import BaseModel from './BaseModel';

export default class CsvExportModel extends BaseModel {
  init(data) {
    this.signed_url = data.signed_url || '';
  }
}
